import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loading } from './Loading';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireApproval?: boolean;
  requireAdmin?: boolean;
}

export function ProtectedRoute({
  children,
  requireApproval = true,
  requireAdmin = false,
}: ProtectedRouteProps) {
  const { isLoading, isAuthenticated, isApproved, isAdmin, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loading text="驗證中..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireApproval && !isApproved) {
    if (user?.status === 'rejected') {
      return <Navigate to="/rejected" replace />;
    }
    return <Navigate to="/pending-approval" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/novels" replace />;
  }

  return <>{children}</>;
}
